import React from 'react'
import {
  Button,
  Header,
  Confirm,
} from 'semantic-ui-react'
import {
  withRouter
} from 'react-router'

class DeleteSelectionPane extends React.Component {
  state = { open: false }

  open = () => this.setState({ open: true })
  handleConfirm = () => {
    this.props.onDelete(this.props.selection.id);
    console.log("TODO: DELETE");
    this.setState({ open: false });
    this.props.history.push('/selections');
  }
  handleCancel = () => this.setState({ open: false })

  render() {
    return (
      <div style={{marginTop: '2em'}}>
        <Header as='h2'>Delete Selection</Header>
        <p>
          If you are certain that you do not need this selection anymore,
          you can delete it.
        </p>
        <Button color='red' onClick={this.open}>Delete</Button>
        <Confirm
          open={this.state.open}
          onCancel={this.handleCancel}
          onConfirm={this.handleConfirm}
          header='Confirm Deletion'
          content={
            <div className='content'>
              <p>
                Do you really want to delete selection <strong>{this.props.selection.name} ({this.props.selection.id})</strong>?
              </p>
              <p>
                It contains {Object.keys(this.props.selection.items).length} items.
              </p>
            </div>
          }
          cancelButton='Cancel'
          confirmButton='Delete Selection'
        />
      </div>
    );
  }
}

export default withRouter(DeleteSelectionPane)